import type { FC, PropsWithChildren } from 'react';
import { createContext, useState } from 'react';

import type {
  DataChangedType,
  DialogConfirmationType,
  DialogContextType,
  DialogPreActionType,
} from '../../types/dialog-context';

export const DialogContext = createContext<DialogContextType | undefined>(
  undefined
);

export const DialogContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [dataChanged, setDataChanged] = useState<DataChangedType>(false);
  const [dialogConfirmation, setDialogConfirmation] =
    useState<DialogConfirmationType>(null);
  const [dialogPreAction, setDialogPreAction] =
    useState<DialogPreActionType>(null);

  const executeWithDialog = (action: () => void): void => {
    if (dataChanged) {
      setDialogConfirmation({
        dialogAction: () => {
          setDialogConfirmation(null);
          setDataChanged(false);
          action();
        },
      });
    } else {
      action();
    }
  };

  return (
    <DialogContext.Provider
      value={{
        dataChanged,
        setDataChanged,
        dialogConfirmation,
        setDialogConfirmation,
        dialogPreAction,
        setDialogPreAction,
        executeWithDialog,
      }}
    >
      {children}
    </DialogContext.Provider>
  );
};
